var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.isNotABot)?_c('vue-friendly-iframe',{staticClass:"av-iframe",attrs:{"frameborder":"0","src":"//cl.avis-verifies.com/fr/cache/e/5/7/e57d3166-b99f-01d4-e122-5fb1008776f9/widget4/e57d3166-b99f-01d4-e122-5fb1008776f9horizontal_index.html"}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }